export default "__VITE_ASSET__B0e1222r__"